<app-page-title title="Inicio"></app-page-title>
<app-page-loader [load]="pageLoad" label="Tablero" (retry)="init()"></app-page-loader>

@if (data(); as d) {
<div class="dash">

  <!-- Encabezado -->
  <header class="dash__head">
    <div class="dash__hello">
      <span class="dash__eyebrow">{{ today }} · {{ d.shift }}</span>
      <h1>{{ greeting() }}{{ userName() ? ', ' + userName() : '' }}</h1>
      @if (d.actions.length) {
        <p>Tienes @if (urgentCount()) {<b class="t-danger">{{ urgentCount() }} pendiente(s) urgente(s)</b> y }{{ d.actions.length }} en total.</p>
      } @else if (anyModule()) {
        <p>No tienes pendientes. Todo al día.</p>
      }
    </div>
    <div class="dash__filters">
      @if (d.executive?.canSwitch) {
        <label>Ver tablero de
          <select [(ngModel)]="view" (ngModelChange)="reload()">
            @for (p of d.executive!.profiles; track p.key) {
              <option [ngValue]="p.key === 'direccion' ? null : p.key">{{ p.label }}</option>
            }
          </select>
        </label>
      }
      <label>Hospital
        <select [(ngModel)]="place" (ngModelChange)="reload()">
          <option [ngValue]="null">{{ d.scoped && !place ? 'Mis hospitales' : 'Todos' }}</option>
          @for (p of d.places; track p.id) { <option [ngValue]="p.id">{{ p.name }}</option> }
        </select>
      </label>
      <button mat-stroked-button type="button" (click)="reload()" matTooltip="Actualizar"><mat-icon>refresh</mat-icon></button>
    </div>
  </header>

  @if (!anyModule()) {
    <div class="card empty">
      <mat-icon>lock</mat-icon>
      <p>Tu rol todavía no tiene módulos con información para el tablero. Pide a un administrador que te los asigne.</p>
    </div>
  }

  <!-- Tablero ejecutivo por rol -->
  @if (d.executive; as ex) {
    @if (ex.kpis.length || ex.charts.length) {
      <section class="block">
        <div class="block__head">
          <h2>Indicadores · {{ ex.profileLabel }}</h2>
          <span>Mes en curso · solo tus hospitales</span>
        </div>
        @if (ex.kpis.length) {
          <div class="xkpis">
            @for (k of ex.kpis; track k.key) {
              <button type="button" class="card xkpi" [class.xkpi--link]="!!k.route" [disabled]="!k.route"
                      (click)="k.route && go(k.route)">
                <span class="kpi__label">{{ k.label }}</span>
                <span class="xkpi__value">{{ kpiValue(k.value, k.format) }}</span>
                @if (k.hint) { <span class="kpi__text tone--{{ k.tone }}">{{ k.hint }}</span> }
              </button>
            }
          </div>
        }
        @if (ex.charts.length) {
          <div class="xcharts">
            @for (c of ex.charts; track c.key) {
              <app-exec-chart [chart]="c" [class.xchart--wide]="c.type === 'bar' || c.type === 'line'" (open)="go($event)" />
            }
          </div>
        }
      </section>
    }
  }

  <!-- Qué tengo que hacer -->
  @if (d.actions.length) {
    <section class="block">
      <div class="block__head"><h2>Qué tengo que hacer</h2><span>Ordenado por urgencia</span></div>
      <div class="actions">
        @for (a of d.actions; track a.key) {
          <div class="card action">
            <div class="action__top">
              <span class="pill pill--{{ a.level }}">{{ levelLabel[a.level] }}</span>
              <span class="muted">{{ a.module }}</span>
            </div>
            <div class="action__main">
              <span class="action__num num--{{ a.level }}">{{ a.count }}</span>
              <span class="action__title">{{ a.title }}</span>
            </div>
            <p class="action__detail">{{ a.detail }}</p>
            <button type="button" class="link" (click)="go(a.route)">{{ a.cta }} <mat-icon>arrow_forward</mat-icon></button>
          </div>
        }
      </div>
    </section>
  }

  <!-- Indicadores -->
  @if (!d.executive && d.kpis.length) {
    <section class="block">
      <div class="block__head"><h2>Cómo vamos este mes</h2></div>
      <div class="kpis">
        @for (k of d.kpis; track k.key) {
          <div class="card kpi">
            <span class="kpi__label">{{ k.label }}</span>
            <span class="kpi__value">{{ k.value.toLocaleString('es-MX') }}</span>
            <span class="kpi__text tone--{{ k.tone }}">{{ k.text }}</span>
          </div>
        }
      </div>
    </section>
  }

  <!-- Salud por hospital + actividad -->
  @if (d.health.length || d.feed.length) {
    <div class="split">
      @if (d.health.length) {
        <section class="card split__main">
          <div class="block__head"><h2>Salud por hospital</h2><span>El semáforo toma lo peor de cada renglón</span></div>
          <div class="scroll-x">
            <table class="health">
              <thead><tr>
                <th>Hospital</th><th>Estado</th>
                @if (mods().folios) { <th class="r">Cirugías del mes</th><th class="r">Borradores</th> }
                @if (mods().inventory) { <th>Caducidad</th> }
                @if (mods().incidents) { <th class="r">Incidencias</th> }
                @if (mods().transfers) { <th class="r">Traspasos</th> }
              </tr></thead>
              <tbody>
                @for (h of d.health; track h.place) {
                  <tr>
                    <td class="b">{{ h.name }}</td>
                    <td><span class="status status--{{ h.status }}"><i></i>{{ h.status }}</span></td>
                    @if (mods().folios) { <td class="r">{{ h.surgeries }}</td><td class="r">{{ h.drafts }}</td> }
                    @if (mods().inventory) {
                      <td><span class="sem"><span class="sem--red" matTooltip="≤ 45 días">{{ h.red }}</span><span class="sem--amber" matTooltip="46 a 60 días">{{ h.amber }}</span><span class="sem--green" matTooltip="Más de 60 días">{{ h.green }}</span></span></td>
                    }
                    @if (mods().incidents) { <td class="r">{{ h.incidents }}</td> }
                    @if (mods().transfers) { <td class="r">{{ h.transfers }}</td> }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </section>
      }
      @if (d.feed.length) {
        <section class="card split__side">
          <div class="block__head"><h2>Actividad reciente</h2></div>
          @for (f of d.feed; track $index) {
            <div class="feed">
              <i class="dot dot--{{ f.tone }}"></i>
              <div><span>{{ f.text }}</span><small>{{ feedWhen(f.when) }}</small></div>
            </div>
          }
        </section>
      }
    </div>
  }

  <!-- Cirugías por mes -->
  @if (d.chart; as c) {
    <section class="card chart">
      <div class="block__head chart__head">
        <div>
          <h2>Cirugías por mes</h2>
          <span>Enero a diciembre · Folio y Remisión · da clic en una barra para ver el detalle por hospital</span>
        </div>
        <div class="chart__tools">
          <span class="legend"><i class="sw sw--folio"></i>Folio · <b>{{ chartTotals().folio }}</b></span>
          <span class="legend"><i class="sw sw--rem"></i>Remisión · <b>{{ chartTotals().remission }}</b></span>
          <label class="year">Año
            <select [(ngModel)]="year" (ngModelChange)="picked.set(null); reload()">
              @for (y of years; track y) { <option [ngValue]="y">{{ y }}</option> }
            </select>
          </label>
        </div>
      </div>

      <div class="bars">
        @for (m of c.months; track m.month) {
          <button type="button" class="bar" [class.bar--on]="picked() === m.month" [class.bar--future]="m.future"
                  [disabled]="m.future" (click)="pickMonth(m)"
                  [attr.aria-pressed]="picked() === m.month"
                  [attr.aria-label]="m.future ? m.label + ': sin datos todavía' : m.label + ': ' + m.folio + ' folios y ' + m.remission + ' remisiones'">
            @if (!m.future) { <span class="bar__total">{{ m.folio + m.remission }}</span> }
            <span class="bar__stack" [style.height.%]="barHeight(m)">
              <span class="bar__rem" [style.flex]="m.remission"></span>
              <span class="bar__folio" [style.flex]="m.folio"></span>
            </span>
          </button>
        }
      </div>
      <div class="bars__labels">
        @for (m of c.months; track m.month) {
          <span [class.on]="picked() === m.month" [class.future]="m.future">{{ monthShort[m.month - 1] }}</span>
        }
      </div>

      @if (selectedMonth(); as s) {
        <div class="detail">
          <div class="detail__head">
            <div>
              <b>{{ s.label }} {{ c.year }} · {{ s.folio + s.remission }} cirugías</b>
              <span>{{ s.folio }} por folio · {{ s.remission }} por remisión · {{ selectedDelta() }}</span>
            </div>
            <button mat-stroked-button type="button" (click)="picked.set(null)">Cerrar</button>
          </div>
          @if (s.byPlace.length) {
            <div class="scroll-x">
              <table class="health">
                <thead><tr><th>Hospital</th><th class="r">Folios</th><th class="r">Remisiones</th><th class="r">Total</th><th class="w34">Participación</th></tr></thead>
                <tbody>
                  @for (r of s.byPlace; track r.place) {
                    <tr>
                      <td class="b">{{ r.name }}</td>
                      <td class="r">{{ r.folio }}</td>
                      <td class="r">{{ r.remission }}</td>
                      <td class="r b">{{ r.folio + r.remission }}</td>
                      <td>
                        <span class="sharebar">
                          <span class="sharebar__track">
                            <span class="bar__folio" [style.width.%]="share(r.folio, s.folio + s.remission)"></span>
                            <span class="bar__rem" [style.width.%]="share(r.remission, s.folio + s.remission)"></span>
                          </span>
                          <small>{{ share(r.folio + r.remission, s.folio + s.remission) | number:'1.0-0' }}%</small>
                        </span>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <p class="muted">Sin cirugías registradas en este mes.</p>
          }
          <button type="button" class="link" (click)="go('/interventions/folios')">Ver folios <mat-icon>arrow_forward</mat-icon></button>
          <button type="button" class="link" (click)="go('/interventions/remissions')">Ver remisiones <mat-icon>arrow_forward</mat-icon></button>
        </div>
      }

      <div class="chart__foot">
        <span>Acumulado del año: <b>{{ chartTotals().total.toLocaleString('es-MX') }}</b></span>
        <span>Promedio mensual: <b>{{ chartTotals().avg }}</b></span>
        <span>Remisiones: <b>{{ chartTotals().remPct }}%</b> del total</span>
        <span>Mes más alto: <b>{{ chartTotals().top }}</b></span>
      </div>
    </section>
  }
</div>
}
